export const DRAFT_ROOM_MODES = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
};

export const DRAFT_ROOM_MODE_STORAGE_KEY = 'leaguerunner-draft-room-mode';

export const normalizeDraftRoomMode = (value) => {
  if (value === DRAFT_ROOM_MODES.BASIC || value === DRAFT_ROOM_MODES.ADVANCED) {
    return value;
  }

  return DRAFT_ROOM_MODES.ADVANCED;
};

export const getStoredDraftRoomMode = () => {
  if (typeof window === 'undefined') {
    return DRAFT_ROOM_MODES.ADVANCED;
  }

  return normalizeDraftRoomMode(window.localStorage.getItem(DRAFT_ROOM_MODE_STORAGE_KEY));
};

export const persistDraftRoomMode = (mode) => {
  const normalizedMode = normalizeDraftRoomMode(mode);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(DRAFT_ROOM_MODE_STORAGE_KEY, normalizedMode);
  }

  return normalizedMode;
};

export const buildDraftRoomPath = (draftId, { mode, chooseView = false, searchParams } = {}) => {
  const params = new URLSearchParams(searchParams || undefined);

  if (mode) {
    params.set('view', normalizeDraftRoomMode(mode));
  }

  if (chooseView) {
    params.set('chooseView', '1');
  } else {
    params.delete('chooseView');
  }

  const query = params.toString();
  return {
    pathname: `/draft/${draftId}`,
    search: query ? `?${query}` : '',
  };
};
